//
// Abstract base class.
function ANBiddingLibrary(logger){

    this.__logger      = logger;
    this.__initialized = false;
}

/**
 * Initialize the library.
 */
ANBiddingLibrary.prototype.init = function(){

    if(this.__initialized){
        
        return;
    }

    this.__init();

    this.__initialized = true;
};

/**
 * Sets up an auction.
 * 
 * @param object auction 
 * @param object overrideDimensions 
 * returns object
 */
ANBiddingLibrary.prototype.setupAuction = function(auction, overrideDimensions){

    this.init();

    return auction;
};

/**
 * Initialize the library.
 */
ANBiddingLibrary.prototype.__init = function(){};

window.ANBiddingLibrary = ANBiddingLibrary;